import axios from 'axios';
import * as apiURL from './apiConfig';

export const DASHBOARD_INSIGHTS_URL = `${apiURL.BASE_URL}/dashboard/insights`;

export const getDashboardInsights = async () => {
  try {
    const response = await axios.get(DASHBOARD_INSIGHTS_URL);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
